/**
 * EL RESTO DEL DÍA QUE VIAJA CON UNA COMIDA AL MOTOR (`contexto_dia`).
 *
 * El tramo de la calibración (frutos secos, cereales) lo decide el día entero (3-09): si solo
 * viaja una comida, el servidor la mide con un día de cero gramos de lo demás y cuenta otros
 * macros que la pantalla. El resto del día va aparte, solo ids y cantidades, y no se toca.
 *
 * Se escribía igual en cinco sitios de NutritionPage, y repetir una comida no lo mandaba:
 * con frutos secos en otra comida, «qué le falta» podía salir distinto que en la tarjeta
 * (revisión del 14-10). Ahora todos lo sacan de aquí.
 *
 * `fuera`: las comidas que NO van en el contexto (las que se mandan a cuadrar).
 */
export const contextoDelDia = (mealsData, orden, fuera = []) => Object.fromEntries((orden || [])
    .filter((k) => !fuera.includes(k))
    .map((k) => [k, ((mealsData || {})[k]?.alimentos || []).map((a) => ({
        alimento_id: a.alimento_id ?? null,
        cantidad_g: a.cantidad_g ?? 0,
    }))]));
